import { useCallback } from 'react';
import { EVENT_SPACING, MINIMUM_EVENT_HEIGHT } from '../../constants';
import type { CalendarEvent, EventWithDimensions } from '../../types';

export const useGetEventStyle = () =>
  useCallback(
    <T extends CalendarEvent>({
      event: { height, left, top, width },
      includePositioning = true,
    }: {
      event: EventWithDimensions<T>;
      includePositioning?: boolean;
    }) => {
      const baseStyle = {
        height: `${Math.max(height - 2 * EVENT_SPACING, MINIMUM_EVENT_HEIGHT)}px`,
      };

      if (includePositioning) {
        return {
          ...baseStyle,
          left: `calc(${left}% + ${EVENT_SPACING}px)`,
          position: 'absolute' as const,
          top: `calc(${top}px + ${EVENT_SPACING}px)`,
          width: `calc(${width}% - 2 * ${EVENT_SPACING}px)`,
        };
      }

      // When not including positioning, override CSS position: absolute with relative
      // and ensure it fills the wrapper
      return {
        ...baseStyle,
        bottom: 'auto',
        left: 0,
        position: 'relative' as const,
        right: 'auto',
        top: 0,
      };
    },
    [],
  );
